import React, { lazy } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Guardian from './app/Guardian';
import './App.css';


const Index = lazy(() => import("./pages/Login/Index"));
const Leads = lazy(() => import("./pages/Login/Lead"));

const Main = lazy(() => import("./pages/Layout/Main"));
const Tickets = lazy(() => import("./pages/Tickets/Index"));
const ViewTickets = lazy(() => import("./pages/Tickets/View"));

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">      
        <Routes>      
          <Route path="/" element={<Index/>} />                              
          <Route path="/Leads" element={<Leads/>} />      

          <Route path="/" element={<Guardian/>}> 
            <Route path="/main" element={<Main/>} />                              
            <Route path="/tickets" element={<Tickets/>} />                              
            <Route path="/tickets/:id" element={<ViewTickets/>} />                              
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
